module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-circle-cbb968d2.svg";